import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-ivory py-14 sm:py-24" aria-labelledby="faq-title" data-id="element-46" data-mp="1gjbyhiw26703">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-47" data-mp="24969rw0qbni8">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-14" data-id="element-48" data-mp="249zmreqa798t">
          <div className="lg:col-span-4" data-id="element-49" data-mp="28b1dt8a1oezp">
            <SectionTag data-id="element-50" data-mp="28a03j60urwj1">Preguntas</SectionTag>
            <h2 id="faq-title" className="mt-4 font-display text-[1.5rem] uppercase leading-[1.08] text-charcoal sm:text-[2.1rem]" data-id="element-51" data-mp="1ujwksp16mkyc">
              Lo que se pregunta antes de empezar
            </h2>
            <p className="mt-4 font-sans text-[0.88rem] leading-relaxed text-charcoal/60" data-id="element-52" data-mp="2n6hdbste933h">
              Es un sistema de asistencia y productividad. La decisión profesional, la revisión de
              cada material y la indicación al paciente son siempre del nutricionista.
            </p>
          </div>

          <div className="lg:col-span-8" data-id="element-53" data-mp="10vjmlyirmozy">
            <ul className="divide-y divide-warm border-y border-warm" data-id="element-54" data-mp="1eln3e9yvlqi0">
              {FAQS.map((faq, index) => {
              const isOpen = open === index;
              return <li key={faq.question} data-id="element-55" data-mp="1oj185cbfsquh" data-mpi={index}>
                    <h3 data-id="element-56" data-mp="1ohygv3a7cme1">
                      <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[60px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-57" data-mp="1ole08iawshl9">
                        <span className="font-sans text-[0.92rem] font-semibold leading-snug text-charcoal sm:text-[1rem]" data-id="element-58" data-mp="3ud180b5dgzry">
                          {faq.question}
                        </span>
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold-pale" aria-hidden data-id="element-59" data-mp="237egjweaxods">
                          <PlusIcon className={`h-4 w-4 text-gold-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-60" data-mp="2c9xhuc2fvsxx" />
                        </span>
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-61" data-mp="2qzv950vo0yrc">
                      {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.22,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-62" data-mp="2vw2ashh13o3h">
                          <p className="max-w-2xl pb-5 pr-6 font-sans text-[0.88rem] leading-relaxed text-charcoal/65" data-id="element-63" data-mp="k9024si6zf1y">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}